import { Switch } from "@mantine/core";
import { useState } from "react";
import { useUpdateTicket } from "../../api/tickets";

function TicketSwitch({ checked, ticketId, columnName }) {
  const [isChecked, setIsChecked] = useState(checked);

  const { mutate } = useUpdateTicket({ ticketId });

  if (!columnName) {
    return null;
  }

  const handleCheckboxChange = () => {
    const next = !isChecked;
    setIsChecked(next);
    const value =
      columnName === "checkedInAt"
        ? next
          ? new Date().toISOString()
          : null
        : next;
    const body = { [columnName]: value };
    if (columnName === "checkedInAt") {
      body.checkInMethod = "hand";
    }
    mutate(body, { onError: () => setIsChecked(!next) });
  };

  return (
    <Switch
      color="green"
      checked={isChecked}
      onChange={() => {
        handleCheckboxChange();
      }}
    />
  );
}

export default TicketSwitch;
